import { AddCircleOutline, ArrowForward, Delete, Edit, Info } from '@mui/icons-material'
import { Button, Card, CardActions, CardContent, CardHeader, Chip, Container, CssBaseline, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup, Tooltip, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, Outlet, useOutletContext } from 'react-router-dom'
import Swal from 'sweetalert2'
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs'
import { AuthStore, NotifStore } from '../../../../store/UserStore'
import { base_url } from '../../../../utils/GlobalVariables'
import { CustomDescrypt } from '../../../../utils/MyEncryption'
import no_data from '../../../../assets/images/no_data.webp'
import MyDialog from '../../../../components/MyDialog'

const Pencairan = () => {
    const [breadcrumbItem, setBreadcrumbItem] = useState({})

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Permintaan" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet context={{ setBreadcrumbItem }} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const Data = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [deleting, setDeleting] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialog2, setOpenDialog2] = useState(false);
    const [dialogData, setDialogData] = useState({});
    const [valueSelect1, setValueSelect1] = useState("");
    const [valueSelect2, setValueSelect2] = useState("");
    const [disableBtn, setDisableBtn] = useState(true)
    // const [value, setValue] = useState('1');
    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    // };

    const handleColor = (params) => {
        let color = "";
        switch (params) {
            case "0":
                color = "primary";
                break;
            case "1":
                color = "info";
                break;
            case "2":
                color = "error"
                break;
            case "3":
                color = "success";
                break;

            default:
                break;
        }
        return color;
    }

    const handleLabel = (params) => {
        let label = "";

        switch (params) {
            case "0":
                label = "Baru";
                break;
            case "1":
                label = "Diperbaiki"
                break;
            case "2":
                label = "Ditolak";
                break;
            case "3":
                label = "Acc";
                break;

            default:
                break;
        }

        return label;
    }

    useEffect(() => {
        setBreadcrumbItem({ '/bnd': 'Home', '/bnd/pencairan': 'Permintaan' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const pemberitahuans = NotifStore((state) => state.pemberitahuans);
    const [reqData, setReqData] = useState(true);

    useEffect(() => {
        console.log(pemberitahuans);
        pemberitahuans.length > 0 && setReqData(!reqData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pemberitahuans]);

    useEffect(() => {
        requestData();
        checkBtn()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleting, reqData]);

    const checkBtn = () => {
        // setTableLoading(true)
        console.log('request Data');
        axios.get(
            base_url + '/bnd/pencairan/sp2d_diserahkan_kemarin',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data.pencairan;
                console.log(data);
                data.length > 0 ? setDisableBtn(true) : setDisableBtn(false)
                // setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                // setTableLoading(false)
            })
    }

    const requestData = () => {
        // setTableLoading(true)
        console.log('request Data');
        axios.get(
            base_url + '/bnd/pencairan',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                // setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                // setTableLoading(false)
            })
    }

    const deleteData = (params) => {
        setDeleting(true);
        const frmData = {
            _method: 'DELETE',
            no_spm: params
        }

        Swal.fire({
            title: 'Hapus Data?',
            text: "Operasi tidak dapat Dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal',
            preConfirm: () => {
                return axios.post(
                    base_url + '/bnd/pencairan/delete',
                    frmData,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        requestData();
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    const handleOpenDialog = (params) => {
        setOpenDialog(true);
        setDialogData(params);
        console.log(params);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleOpenDialog2 = () => {
        setOpenDialog2(true);
    };

    const handleCloseDialog2 = () => {
        setOpenDialog2(false);
    };

    const handleSelect1 = (event) => {
        setValueSelect1(event.target.value)
    }

    const handleSelect2 = (event) => {
        setValueSelect2(event.target.value)
    }

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    return (
        <Card variant='outlined'>
            <CardHeader
                title="Data Permintaan"
                action={
                    <Button
                        variant="contained"
                        endIcon={<AddCircleOutline color='white' />}
                        onClick={() => handleOpenDialog2()}
                        disabled={disableBtn}
                    // to="/bnd/spm/add"
                    // component={Link}
                    >
                        Tambah
                    </Button>
                }
            />
            <CardContent>
                {/* <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                <Tab icon={<Assignment />} label="SPM Diajukan" value="1" />
                                <Tab icon={<AssignmentTurnedIn />} label="SPM Disetujui" value="2" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <Grid container spacing={2} justifyContent='center'>
                                {
                                    tableData.length > 0 ?
                                        tableData.map((item) => (
                                            <Grid item xs={12} md={6} lg={4} key={item.no_spm}>
                                                <Card>
                                                    <CardHeader
                                                        avatar={
                                                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                                {item.tgl_spm}
                                                            </Typography>
                                                        }
                                                        action={
                                                            <Chip
                                                                label={handleLabel(item.progres)}
                                                                color={handleColor(item.progres)}
                                                                variant="outlined"
                                                            />
                                                        }
                                                    />
                                                    <CardContent>
                                                        <Typography variant="h6">
                                                            {item.jenis + " " + item.jenis_ls}
                                                        </Typography>
                                                        <Typography variant="h5" component="div">
                                                            No. SPM {item.no_spm}
                                                        </Typography>
                                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                            No. SPP {item.no_spp}
                                                        </Typography>
                                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                            {item.keperluan}
                                                        </Typography>
                                                        <Typography variant="h6">
                                                            Rp. {rP(item.anggaran)}
                                                        </Typography>
                                                    </CardContent>
                                                    <CardActions>
                                                        <Tooltip title="Hapus">
                                                            <IconButton aria-label="delete" color='error' onClick={() => deleteData(item.no_spm)}>
                                                                <Delete />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Edit">
                                                            <IconButton
                                                                aria-label="edit"
                                                                color="info"
                                                                component={Link}
                                                                to="/bnd/pencairan/edit"
                                                                state={{ jenis: item.jenis, jenis_ls: item.jenis_ls, pencairan: item }}
                                                            // state={item}
                                                            >
                                                                <Edit />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Info">
                                                            <IconButton aria-label="confirm" color='success' onClick={() => handleOpenDialog(item)}>
                                                                <Info />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </CardActions>
                                                </Card>
                                            </Grid>
                                        ))
                                        :
                                        <Grid item lg={6} md={6} sm={12} sx={{ textAlign: "center" }}>
                                            <img
                                                src={no_data}
                                                srcSet={no_data}
                                                alt={"No Data"}
                                                loading="lazy"
                                                sx={{
                                                    objectFit: 'contain',
                                                    padding: "1em 1em 0 1em"
                                                }}
                                            />
                                        </Grid>
                                }
                            </Grid>
                        </TabPanel>
                        <TabPanel value="2">
                            <DataAcc />
                        </TabPanel>
                    </TabContext>
                </Box> */}

                <Grid container spacing={2}>
                    {
                        tableData.length > 0 ?
                            tableData.map((item) => (
                                <Grid item xs={12} md={6} lg={4} key={item.no_spm}>
                                    <Card>
                                        <CardHeader
                                            avatar={
                                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                    {item.tgl_spm}
                                                </Typography>
                                            }
                                            action={
                                                <Chip
                                                    label={handleLabel(item.progres)}
                                                    color={handleColor(item.progres)}
                                                    variant="outlined"
                                                />
                                            }
                                        />
                                        <CardContent>
                                            <Typography variant="h6">
                                                {item.jenis + " " + item.jenis_ls}
                                            </Typography>
                                            <Typography variant="h5" component="div">
                                                No. SPM {item.no_spm}
                                            </Typography>
                                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                No. SPP {item.no_spp}
                                            </Typography>
                                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                {item.keperluan}
                                            </Typography>
                                            <Typography variant="h6">
                                                Rp. {rP(item.anggaran)}
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            {/* {
                                                item.progres !== "3" &&
                                                <> */}
                                                    <Tooltip title="Hapus">
                                                        <IconButton aria-label="delete" color='error' onClick={() => deleteData(item.no_spm)}>
                                                            <Delete />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Edit">
                                                        <IconButton
                                                            aria-label="edit"
                                                            color="info"
                                                            component={Link}
                                                            to="/bnd/pencairan/edit"
                                                            state={{ jenis: item.jenis, jenis_ls: item.jenis_ls, pencairan: item }}
                                                        >
                                                            <Edit />
                                                        </IconButton>
                                                    </Tooltip>
                                                {/* </>
                                            } */}
                                            <Tooltip title="Info">
                                                <IconButton aria-label="confirm" color='success' onClick={() => handleOpenDialog(item)}>
                                                    <Info />
                                                </IconButton>
                                            </Tooltip>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))
                            :
                            <Grid container mt={5} spacing={2} justifyContent="center">
                                <Grid item lg={6} md={6} sm={12} sx={{ textAlign: "center" }}>
                                    <img
                                        src={no_data}
                                        srcSet={no_data}
                                        alt={"No Data"}
                                        loading="lazy"
                                        sx={{
                                            objectFit: 'contain',
                                            padding: "1em 1em 0 1em"
                                        }}
                                    />
                                </Grid>
                            </Grid>
                    }
                </Grid>
            </CardContent>

            <MyDialog dialogData={dialogData} openDialog={openDialog} handleCloseDialog={handleCloseDialog} decryptedUser={decryptedUser} />

            <Dialog
                fullWidth={true}
                maxWidth="xs"
                open={openDialog2}
                onClose={handleCloseDialog2}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">Pilih Jenis SPM</DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item lg={6}>
                            <FormControl>
                                <FormLabel id="demo-controlled-radio-buttons-group">Jenis SPM</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={valueSelect1}
                                    onChange={handleSelect1}
                                >
                                    <FormControlLabel value="UP" control={<Radio />} label="UP" />
                                    <FormControlLabel value="TU" control={<Radio />} label="TU" />
                                    <FormControlLabel value="GU" control={<Radio />} label="GU" />
                                    <FormControlLabel value="LS" control={<Radio />} label="LS" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {
                            valueSelect1 === "LS" &&
                            <Grid item lg={6}>
                                <FormControl>
                                    <FormLabel id="demo-controlled-radio-buttons-group">Jenis LS</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={valueSelect2}
                                        onChange={handleSelect2}
                                    >
                                        <FormControlLabel value="Gaji" control={<Radio />} label="Gaji" />
                                        <FormControlLabel value="Barang Jasa" control={<Radio />} label="Barang Jasa" />
                                        <FormControlLabel value="Modal" control={<Radio />} label="Modal" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        disabled={valueSelect1 + valueSelect2 === "" || valueSelect1 + valueSelect2 === "ls" ? true : false}
                        variant="contained"
                        endIcon={<ArrowForward color='white' />}
                        to="/bnd/pencairan/add"
                        state={{ jenis: valueSelect1, jenis_ls: valueSelect2, pencairan: null }}
                        component={Link}
                    >
                        Pilih
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>

    )
}

export default Pencairan
export { Data as DataPencairan }